import CallCenterOnIcon from './CallCenterOn.icon';

export default CallCenterOnIcon;
